/**
 * @generated SignedSource<<c87cbe856211a6ab0f8e91d09f615d46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type InitiateCheckoutInput = {
  agentDetails?: AgentDetailsRequest | null;
  cartId: string;
  channel: CartChannel;
};
export type AgentDetailsRequest = {
  channelName: string;
  dealerCode: string;
  salesAgentId: string;
};
export type useInitiateCheckoutMutation$variables = {
  input: InitiateCheckoutInput;
};
export type useInitiateCheckoutMutation$data = {
  readonly initiateCheckout: {
    readonly message: string;
    readonly code: number;
    readonly success: boolean;
  };
};
export type useInitiateCheckoutMutation = {
  variables: useInitiateCheckoutMutation$variables;
  response: useInitiateCheckoutMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InitiateCheckoutResponse",
    "kind": "LinkedField",
    "name": "initiateCheckout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useInitiateCheckoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInitiateCheckoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2c934fd8e520859210efd8cd0eefeb09",
    "id": null,
    "metadata": {},
    "name": "useInitiateCheckoutMutation",
    "operationKind": "mutation",
    "text": "mutation useInitiateCheckoutMutation(\n  $input: InitiateCheckoutInput!\n) {\n  initiateCheckout(input: $input) {\n    message\n    code\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "88803cfec43d0eeeca2812bef47b91ef";

export default node;
